import { useUserStore } from '@/stores/user';
import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createActivityPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;
    const userStore = useUserStore();
    const isAdmin = userStore.isAdmin();

    return [
        {
            title: '',
            value: 'select',
            key: 'select',
            align: 'center',
            sortable: false,
            minWidth: 20,
            width: 20,
            cellProps: { class: 'px-0' },
            headerProps: { class: 'px-0' },
        },
        {
            title: t('bets.date'),
            value: 'date',
            key: 'date',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.date'), class: 'nowrap' },
        },
        {
            title: t('bets.user'),
            value: 'user',
            key: 'user',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.user'), class: 'nowrap' },
        },
        {
            title: t('bets.botOrder'),
            value: 'botOrder',
            key: 'botOrder',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.botOrder'), class: 'nowrap' },
        },
        {
            title: t('bets.status'),
            value: 'status',
            key: 'status',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.status'), class: 'nowrap' },
        },
        {
            title: t('bets.marketType'),
            value: 'marketType',
            key: 'marketType',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.marketTypeTooltip'), class: 'nowrap' },
        },
        {
            title: t('bets.period'),
            value: 'period',
            key: 'period',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.periodTooltip'), class: 'nowrap' },
        },
        {
            title: t('bets.book'),
            value: 'book',
            key: 'book',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.bookTooltip'), class: 'nowrap' },
        },
        {
            title: t('bets.account'),
            value: 'account',
            key: 'account',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.account'), class: 'nowrap' },
        },
        {
            title: t('bets.game'),
            value: 'game',
            key: 'game',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.game'), class: 'nowrap' },
        },
        {
            title: t('bets.bet'),
            value: 'bet',
            key: 'bet',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.bet'), class: 'nowrap' },
        },
        {
            title: t('bets.plOdds'),
            value: 'plOdds',
            key: 'plOdds',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.plOddsTooltip'), class: 'nowrap' },
        },
        {
            title: t('bets.openOdds'),
            value: 'openOdds',
            key: 'openOdds',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.openOddsTooltip'), class: 'nowrap' },
            hidden: !isAdmin,
        },
        {
            title: t('bets.closeOdds'),
            value: 'closeOdds',
            key: 'closeOdds',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.closeOddsTooltip'), class: 'nowrap' },
            hidden: !isAdmin,
        },
        {
            title: t('bets.betVsOpen'),
            value: 'betVsOpen',
            key: 'betVsOpen',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.betVsOpenTooltip'), class: 'nowrap' },
            hidden: !isAdmin,
        },
        {
            title: t('bets.betVsClose'),
            value: 'betVsClose',
            key: 'betVsClose',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.betVsCloseTooltip'), class: 'nowrap' },
            hidden: !isAdmin,
        },
        {
            title: t('bets.score'),
            value: 'score',
            key: 'score',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.scoreTooltip'), class: 'nowrap' },
        },
        {
            title: t('bets.stake'),
            value: 'stake',
            key: 'stake',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.tooltips.stakeTooltip'), class: 'nowrap' },
        },
        {
            title: t('bets.ftScore'),
            value: 'ftScore',
            key: 'ftScore',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.ftScore'), class: 'nowrap' },
        },
        {
            title: t('bets.balance'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('bets.balance'), class: 'nowrap' },
        },
        {
            title: t('bets.message'),
            value: 'message',
            key: 'message',
            align: 'start',
            sortable: false,
            cellProps: { style: 'min-width: 280px; max-width: 400px;' },
            headerProps: { 'data-tooltip': t('bets.message'), class: 'nowrap v-data-table-column--align-center' },
        },
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 72, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
